export interface RESPONCE<T> {
  State: number;
  Result: T;
  Message: string;
  TotalCount?: number;
}

export interface PAGING_PARAMS {
  PageSize?: number;
  PageNumber?: number;
  FreeText?: string;
}

export interface USER_BRANCHS_PARAMS extends PAGING_PARAMS {
  branchId: number;
  PageSize?: number;
  PageNumber?: number;
  FreeText?: string;
}

export interface SUCCESS_RESPONCE<T> {
  state: number;
  data: T;
  totalCount?: number;
}
